import swal from "sweetalert";

function AlertRequest(callback) {
  swal({
    title: "Solicitud exitosa",
    text: "pronto un asesor contactará contigo",
    icon: "success",
    button: "Aceptar",
  }).then(callback);
}

function ErrorRequest(callback) {
  swal({
    title: "Solicitud fallida",
    text: "Hubo un error al solicitar la póliza, intenta de nuevo más tarde",
    icon: "error",
    button: "Aceptar",
  }).then(callback);
}

function QuestionRequest(callback) {
  swal({
    title: "Atención",
    text: "Te informamos que tu solicitud está a punto de ser enviada a un asesor/a.  ¿Estás seguro/a de que deseas solicitar esta póliza?",
    icon: "info",
    buttons: {
      Cancelar: true,
      Aceptar: true,
    },
    confirmButtonColor: "#fff",
  }).then(callback);

}
export { AlertRequest, ErrorRequest, QuestionRequest };
